export default "__VITE_ASSET__BAoJwer7__"